import adminLoginApi from 'apis/loginApi';
import useAsync from 'hooks/base/useAsync';
import { isNil } from 'lodash';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalStore from 'stores/globalStore';
import moment from 'moment';
import { setItem } from 'utils/local-storage';
import { ACCESS_TOKEN, USER_PROFILE } from 'utils/storage-keys';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

interface LoginParam {
  email?: string;
  password?: string;
  gCaptcha?: string;
  facebook_token?: string;
  apple_token?: string;
  google_token?: string;
  google_email?: string;
}

const useLoginApi = () => {
  const { status, execute, value } = useAsync(adminLoginApi, false);
  const navigate = useNavigate();
  const { storeSession } = GlobalStore.useContainer();
  const { t } = useTranslation();

  const login = React.useCallback(
    ({ email, password, gCaptcha, facebook_token, apple_token, google_token, google_email }: LoginParam) => {
      execute(email, password, gCaptcha, facebook_token, apple_token, google_token, google_email);
    },
    [execute]
  );

  React.useEffect(() => {
    if (isNil(value)) {
      return;
    }

    if (value.error) {
      switch(value.statusCode) {
        case 400:
          message.error(t('login.status_400'));
          break;
        case 404:
          message.error(t('login.status_404'));
          break;
        case 409:
          message.error(t('login.status_409'));
          break;
        case 429:
          message.error(t('login.status_429'));
          break;
        case 441:
          message.error(t('login.status_441'));
          break;
        case 500:
          message.error(t('login.status_500'));
          break;
      }
      return;
    }

    if (isNil(value.data)) {
      // message.warn("Empty Body");
      return;
    }

    storeSession(value.data.session, moment().add(1, 'days').toDate());
    setItem(ACCESS_TOKEN, value.data.session);
    setItem(USER_PROFILE, JSON.stringify(value.data.profile));

    const redirect = new URLSearchParams(window.location.search).get('redirect') || '/';
    navigate(redirect);
  }, [navigate, storeSession, value, t]);

  return {
    isLoading: status === 'pending',
    login
  };
};

export default useLoginApi;
